import { ReportsZeroState } from 'ui/illustrations';
import { AlternativeState } from './AlternativeStateTemplate';

export const EmptyStateCopy = {
  title: 'No snippet data available',
  subtitle: "There's no Dynamic URL data for your selected time frame.",
};

export const EmptyState = () => (
  <AlternativeState
    Illustration={ReportsZeroState}
    title={EmptyStateCopy.title}
    subtitle={EmptyStateCopy.subtitle}
  />
);
